import React from "react";
import {Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {LoadingBoton} from "../../../_helpers";
import {userService} from "../../../_services";
import alertService from "../../../_services/cart/alert.service";

/**
 * Blanqueo de clave desde el panel del admin.
 *
 * <p>Pide confirmación en vez de blanquear con un click porque la acción deja a la persona afuera
 * de su cuenta hasta que abra el mail: no hay forma de deshacerla.
 *
 * <p>La clave nueva la genera el backend y viaja sólo al mail del usuario — el admin nunca la ve,
 * así que acá no hay nada que mostrar ni que copiar.
 */
class FormResetearPassword extends React.Component {

    state = {
        grabando: false
    };

    resetear = () => {
        const {usuario, handleClose} = this.props;

        this.setState({grabando: true});

        userService.resetearPasswordAdmin(usuario.id).then(
            () => {
                this.setState({grabando: false});
                alertService.msg("Le mandamos la contraseña nueva a " + usuario.email);
                handleClose();
            },
            (error) => {
                this.setState({grabando: false});
                alertService.error(error);
            }
        );
    };

    render() {
        const {usuario, show, handleClose} = this.props;

        return (
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesomeIcon icon="fa-solid fa-key"/> Blanquear contraseña
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Se le va a generar una contraseña nueva y se la vamos a mandar por mail a{" "}
                        <strong>{usuario.email}</strong>.
                    </p>
                    <p>
                        La contraseña actual deja de funcionar en el momento. Vos no vas a ver la nueva:
                        sólo le llega a la casilla del usuario.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="button" data-type="secondary" type="button"
                            onClick={handleClose} disabled={this.state.grabando}>
                        Cancelar
                    </button>
                    <button className="button" data-type="primary" type="button"
                            onClick={this.resetear} disabled={this.state.grabando}>
                        Blanquear y enviar <LoadingBoton grabando={this.state.grabando}/>
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export {FormResetearPassword};
